<template>
  <v-navigation-drawer
    v-model="drawer"
    right
    fixed
    temporary
  >
    <v-list>
      <v-list-item
        v-for="(link, i) in theLinks"
        :key="i"
        :to="{
          name: link
        }"
        active-class="primary--text font-weight-bold"
        class="subtitle-1"
        exact
        min-width="128"
        text
      >
        <v-list-item-content>
          <v-list-item-title v-text="link" />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <div class="py-8">
        <router-link to="/">
          <v-img
            :src="require('../../../assets/ColorfullyUniqueLogo.svg')"
            class="mx-auto mb-8"
            max-width="128"
          />
        </router-link>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import { mapState } from 'vuex'

  export default {
    name: 'CoreDrawer',

    computed: {
      ...mapState(['links']),
      theLinks () {
        let ret = this.links
        if (this.userIsAuthenticated) {
          ret = ret.filter(l => l !== 'Sign Up' && l !== 'Sign In')
        } else {
          ret = ret.filter(l => l !== 'User Area')
        }
        return ret
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('setDrawer', val)
        },
      },
    },
  }
</script>

<style scoped>
/deep/ .primary--text {
  color: black !important
}
</style>
